import React, { useState, useCallback, useEffect } from 'react';

import CCard from '../../../components/card/card';
import Tabs from '../../../components/vertical-tab/tabs';
import {
  TypeNotification,
  TYPES_NOTIFICATIONS,
  types_notifications_admin
} from '../../../types/menu-notifications';
import styles from '../../notifications/notifications.module.scss';
import '../../../theme/global.scss';
import {
  downloadOneDecision,
  getAllDecisions,
  uploadDecision
} from '../../../network/notifications';
import CUpload from '../../../components/input/upload';
import {
  checkFilesHaveSameType,
  combineFiles,
  handleFileChange,
  initialFile
} from '../../../utils/files';
import CButton from '../../../components/button/button';
import { Space } from '../../../components/utils/utils';
import { notify } from '../../../notifications/notification';
import { prettyDate } from '../../../utils/strings';
import { Pagination } from 'antd';
import { variables } from '../../../utils/variables';
import CDropdown from '../../../components/dropdown/dropdown';
import {
  IInstitution,
  TCallbackVoid
} from '../../../utils/interfaces/interfaces';
import { getInstitutions } from '../../../network/institution';
import { typesFiles } from '../../../types/uploaded-data';
import CModal from '../../../components/modal/modal';
import AddCurteconturi from '../../../components/forms/add_curteconturi';
import axios from 'axios';
import { admin_curteconturAPI } from '../../../network/routes';

const NotificationsAdmin = () => {
  const [currOption, setOption] = useState(types_notifications_admin[0]);
  const [decisions, setDecisions] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [institution, setInstitution] = useState({} as IInstitution);
  const [currentPage, setPage] = useState(1);
  const [info, setInfo] = useState({
    totalRecords: 0
  });
  const [file, setFile] = useState(initialFile);
  const [openedModal, setModal] = useState(false);

  const handleChange = useCallback(
    (value: TypeNotification) => {
      setOption(value);
    },
    [setOption]
  );

  const handleFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: any
  ) => {
    if (
      currOption.key === TYPES_NOTIFICATIONS.HOTARARI &&
      !checkFilesHaveSameType(event.target.files!, typesFiles.pdf)
    ) {
      notify(
        'Unul dintre fișierele încărcate nu este potrivit. Trebuie să încărcați fișiere cu extensie .pdf.',
        'info'
      );
      return;
    } else if (
      currOption.key === TYPES_NOTIFICATIONS.HOTARARI &&
      checkFilesHaveSameType(event.target.files!, typesFiles.pdf)
    )
      handleFileChange(event, setFile);
  };

  const handleSelect = (item: IInstitution) => {
    setInstitution(item);
  };

  const getNotifications = useCallback(() => {
    getAllDecisions(currentPage).then(({ data }) => {
      setDecisions(data.data.data);
      setInfo(data.data);
    });
  }, [currentPage]);

  // const handleSendNotifications = () => {
  //   if (file.length > 0) {
  //     notify('Ați trimis notificările cu succes.', 'success');
  //     uploadInspectionsFile(file[0].name.split('.')[0], file[0]);
  //     getNotifications();
  //     setFile(initialFile);
  //   } else {
  //     notify('Nu ați încărcat niciun fișier.', 'error');
  //   }
  // };

  const handleSendDecision = async () => {
    if (file.length > 0 && institution.name) {
      const decisionDocument = await combineFiles(file, file[0].name);

      /* upload file */
      uploadDecision(
        file[0].name,
        decisionDocument,
        institution.id.toString()
      ).then(() => {
        notify('Ați încărcat o hotărâre.', 'success');
        getNotifications();
        setFile(initialFile);
      });
    } else {
      notify('Nu ați încărcat niciun fișier.', 'error');
    }
  };

  useEffect(() => {
    setPage(1);
    setFile(initialFile);
  }, [currOption]);

  useEffect(() => {
    getNotifications();
    getInstitutions().then(({ data }) => setInstitutions(data.data));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getNotifications();
  }, [currentPage, getNotifications]);

  const addNewDoc = () => {
    setModal(!openedModal);
  };

  const uploadCurteConturiFile = (
    name: string,
    type: string,
    file: File,
    callback: TCallbackVoid
  ) => {
    const data = new FormData();
    data.append('name', name);
    data.append('type', type);
    data.append('file', file);
    axios.post(admin_curteconturAPI.ALL, data).then(() => {
      callback();
    });
  };

  return (
    <div className={styles.container}>
      <Tabs
        options={types_notifications_admin}
        currentOption={currOption}
        onChange={handleChange}
      />
      {/* {currOption.key === TYPES_NOTIFICATIONS.CONTROALE && (
        <div className={styles.content}>
          <div className='justify-start'></div>

          {notifications && (
            <p className='body-dark faded'>Trimite notificările</p>
          )}
          <div className='row'>
            <CUpload
              label='Document Excel'
              id='decision'
              title='Încărcati documentul excel'
              name='decision'
              value={file}
              onChange={e => handleFile(e, setFile)}
            />
            <Space horizontal='20px' />
            <CButton
              label='Trimite notificările'
              type='button'
              onClick={handleSendNotifications}
              className={styles.controlsSubmit}
              disabled={file.length === 0}
            />
          </div>
          <Space vertical='30px' />
          {notifications && (
            <p className='body-dark faded'>Notificări trimise</p>
          )}
          {notifications && (
            <>
              <div className={styles.list}>
                {notifications.length > 0 &&
                  notifications.map((option: any) => (
                    <CCard
                      key={option.id}
                      title={`Ați încărcat documentul ${option.name}`}
                      date={
                        option.hasOwnProperty('createdAt') &&
                        prettyDate(option.createdAt)
                      }
                      downloadLink={() =>
                        downloadOneInspection(option.id, option.name)
                      }
                    />
                  ))}
              </div>
              {notifications && notifications.length > 0 && (
                <div className='row center'>
                  <Pagination
                    defaultCurrent={1}
                    total={info.totalRecords}
                    current={currentPage}
                    pageSize={variables.paginationRatio}
                    onChange={e => setPage(e)}
                  />
                </div>
              )}
              <Space vertical='50px' />
            </>
          )}
        </div>
      )} */}

      {currOption.key === TYPES_NOTIFICATIONS.HOTARARI && (
        <div className={styles.content}>
          <div className='row justify-start'></div>

          {<p className='body-dark faded'>Trimite o notificare nouă</p>}
          <div className={styles.row}>
            <CDropdown
              label='Instituție'
              visiblePhrase={(item: IInstitution) => item.name}
              list={institutions}
              placeholder='Alegeți o instituție'
              onChange={handleSelect}
              currentOption={institution}
            />
            <Space horizontal='20px' />
            <CUpload
              label='Document'
              id='decision'
              title='Încărcați documentul'
              name='decision'
              value={file}
              onChange={e => handleFile(e, setFile)}
            />
            <Space horizontal='20px' />
            <CButton
              disabled={file.length === 0 || !institution || !institution.id}
              label='Trimite notificările'
              type='button'
              onClick={handleSendDecision}
              className={styles.decisionsSubmit}
            />
          </div>
          {decisions && <p className='body-dark faded'>Notificări trimise</p>}
          {decisions && (
            <div className={styles.list}>
              {decisions.length > 0 &&
                decisions.map((option: any) => (
                  <CCard
                    key={option.id}
                    title={`Ați încărcat documentul ${option.name}`}
                    date={
                      option.hasOwnProperty('createdAt') &&
                      prettyDate(option.createdAt)
                    }
                    downloadLink={() =>
                      downloadOneDecision(
                        option.id,
                        option.institutionId,
                        option.name
                      )
                    }
                  />
                ))}
            </div>
          )}
          {decisions && decisions.length > 0 && (
            <div className='row center'>
              <Pagination
                defaultCurrent={1}
                total={info.totalRecords}
                current={currentPage}
                pageSize={variables.paginationRatio}
                onChange={e => setPage(e)}
              />
            </div>
          )}
          <Space vertical='3vh' />
        </div>
      )}

      {currOption.key === TYPES_NOTIFICATIONS.CURTECONTURI && (
        <div className={styles.content}>
          <div className='row justify-start'></div>
          <CModal opened={openedModal} openModal={setModal}>
            <AddCurteconturi
              type={currOption.key}
              submit={uploadCurteConturiFile}
              callback={() => {}}
            />
          </CModal>
          <Space vertical='3vh' />

          <CButton
            label='Adăugați un fișier nou'
            onClick={addNewDoc}
            type='button'
            className={styles.add}
          />

          <Space vertical='3vh' />
        </div>
      )}
    </div>
  );
};

export default NotificationsAdmin;
